import { isRangeFilterActive } from '@features/facetingEngine/utils/facetLogic';
import { Flex, Separator } from '@radix-ui/themes';
import { FacetDatePicker } from './FacetDatePicker';
import { FacetFlow } from './FacetFlow';
import { useFacetController } from '../hooks/useFacetController';
import { RangePreset } from '..';

interface DateFilterProps {
    facetKey: string;
}

export const DateFilter = ({ facetKey }: DateFilterProps) => {
    const { config, value, onChange, getLabel } =
        useFacetController<'date'>(facetKey);

    if (!config) return null;
    const { presets } = config;

    return (
        <Flex direction='column' gap='3'>
            <FacetDatePicker value={value} onChange={onChange} />

            {presets && presets.length > 0 && (
                <>
                    <Separator
                        style={{
                            alignSelf: 'center',
                            width: '80%',
                        }}
                    />

                    <FacetFlow<RangePreset>
                        facets={config.presets ?? []}
                        isActive={(preset) =>
                            isRangeFilterActive(value, preset.value)
                        }
                        onSelect={(preset) => onChange(preset.value)}
                        getLabel={(preset) => getLabel(preset.key)}
                        getKey={(preset) => preset.key}
                    />
                </>
            )}
        </Flex>
    );
};
